import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import './bookingtime.scss';
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiClose, mdiCalendar, mdiClockTimeTwoOutline } from '@mdi/js';
import { Link, Navigate, NavLink, useSearchParams, useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from "axios";
import Modal from 'react-modal';
import agent from '../../agent';
import clockIcon from "../TuneUp/Clock.svg"
import dollarIcon from "../TuneUp/CurrencyBg.svg"
import calendarIcon from "../TuneUp/Calendar.svg"
import orderClockIcon from "../TuneUp/Time.svg"
import durationIcon from "../TuneUp/duration.svg"
import closeIcon from "../TuneUp/CloseIcon.svg"
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import { Helmet } from "react-helmet";
import "react-datepicker/dist/react-datepicker.css";
import Select, { components } from 'react-select';
import dateIcon from '../BookingTime/DateSlot.svg'
import dropdownicon from "../ProfileMenu/images/dropdownicon.png"
import checkSlotTimeIcon from "./TimeSlot.svg";
import CustomFunction from '../../components/customFuction';
import { HANDLE_401_ERROR, USER_LOAD } from '../../constants/actionTypes';
import Q from 'q';
import Footer from '../../components/Footer/Footer';

const mapStateToProps = state => ({ ...state });

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) =>
    dispatch({ type: USER_LOAD, payload, skipTracking: true }),

});


const OrderEdit = (props) => {


  //console.log("Order Edit props", props);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  // console.log("location", location);
  let pathname = location.pathname;
  pathname = pathname.trim().split("/");
  // console.log(pathname);


  const [isLoading, setLoading] = useState(true);
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [orderTimeSlotButtonLoading, setOrderTimeSlotButtonLoading] = useState(false)

  const [bookingInfoError, setBookingInfoError] = useState("");
  const [bookingInfoSuccess, setBookingInfoSuccess] = useState("");
  const [bookingValues, setBookingValues] = useState('');
  const [cardAddPopup, setCardAddPopup] = React.useState(true);


  // Zip code
  const [zipCodeServiceCheck, setZipCodeServiceCheck] = useState("");
  // const [zipCodeServiceData, setZipCodeServiceData] = useState("");

  // ProfileInfo
  const [defaultDate, setDefaultDate] = useState();
  const [ordersData, setOrdersData] = useState('');
  const [bikeTypeList, setBikeTypeList] = useState([]);
  const [bikeTypeOptions, setBikeTypeOptions] = useState([]);
  const [bikeTypes, setBikeTypes] = useState('');
  const [bikeTypeId, setBikeTypeId] = useState('');
  const [bikeMakeList, setBikeMakeList] = useState([]);
  const [bikeMakes, setBikeMakes] = useState('');
  const [bikeModelList, setBikeModelList] = useState([]);
  const [bikeModels, setBikeModels] = useState('');
  const [bikesModelId, setBikesModelId] = useState('');
  const [bikesGearId, setBikesGearId] = useState('');
  const [bikesMakeId,setBikesMakeId] = useState('');
  const [bikesTypeId,setBikesTypeId] = useState('');

  // Booking Slot time data and popup
  const [bookingOrderTimeSlotData, setBookingOrderTimeSlotData] = useState('');
  const [selectOrderTimeSlot, setSelectOrderTimeSlot] = useState('');
  const [bookingOrderError, setBookingOrderError] = useState('');
  const [bookingOrderTimeSlotModalIsOpen, setBookingOrderTimeSlotModalIsOpen] = React.useState(false);
  const [defaultOrderDate, setDefaultOrderDate] = useState('');

  // order booking succes
  const [bookingModalIsOpen, setBookingModalISOpen] = useState(false);
  const [bookingOrderSuccess, setBookingOrderSuccess] = useState('');

  const [orderSuccess, setOrderSuccess] = useState('');
  const [zipcodePopUp, setZipcodePopUp] = useState(false);



  // UseForm React form validation
  const validationSchema = Yup.object({
    address: Yup.string().required('Address is required')
      .matches(/^\S.*\S$/, 'Address should not start or end with whitespaces.')
      .min(6, 'Address should be at least six characters long')
      .max(256, 'Address should not exceed 256 characters.'),
    city: Yup.string(),
    zip_code: Yup.string()
      .matches(/^[\S]*$/, 'Zip code cannot contain whitespace.')
      .matches(/^\d{5}(?:[-]\d{4})?$/, 'Invalid zip code format.'),
    biketype: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    bikemake: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    bikemodel: Yup.object()
      .shape({
        value: Yup.string(),
        label: Yup.string(),
      })
      .nullable()
      .required('This field is required.'),
    order_date: Yup.string().required("Order Date is required."),

  });

  const modalValidationSchema = Yup.object({
    order_slot_time: Yup.object()
      // .shape({
      //   value: Yup.string(),
      //   label: Yup.string(),
      //   disabled: Yup.string(),
      // })
      .nullable()
      .required('Time slot is required.')
  });

  const modalFormOptions = {
    resolver: yupResolver(modalValidationSchema)
  };

  const formOptions = {
    resolver: yupResolver(validationSchema),

  };
  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm(formOptions);

  const { handleSubmit: modalhandleSubmit, setValue: setModalValue, control: modalControl, formState: { errors: modalErrors } } = useForm(modalFormOptions);



  const convertArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
      return {
        value: item.value, label: item.label
      };
    }, initialValue);
  };

  const CaretDownIcon = () => {
    return <img className="fas fa-caret-down" src={dropdownicon} alt='No Image' />;
  };

  const CheckSlotIcon = () => {
    return <img className="fas fa-caret-down" src={checkSlotTimeIcon} alt='check slot time icon' />;
  };

  const DropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{ width: "0px !important" }} {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const timeDropdownIndicator = props => {
    return (
      <components.DropdownIndicator style={{ width: "0px !important" }} {...props}>
        <CheckSlotIcon />
      </components.DropdownIndicator>
    );
  };

  const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      value={value}
      className="example-custom-input"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
    ></input>
  ));

  const cardAddPopupClose = () => {
    setCardAddPopup(false);
    refreshPage();
  }

  function refreshPage() {
    window.location.reload(false);
  }

  function closeModelZipcode() {
    setZipcodePopUp(false)
 }

  //   const getProfileInfo = async () => {
  //     setLoading(true)
  //     const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //     try {
  //       const config = {
  //         headers: { 
  //           "Content-Type": "application/json",
  //           'Authorization': `Bearer ${accessToken}`
  //         },
  //       };
  //       const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'auth/userinfo', config);
  //       setUserData(data)
  //       const [types, makes, models] = await Promise.all([
  //         axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/types', config),
  //         axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/make', config),
  //         axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT+'vehicle/model', config)
  //       ]);
  //       setVehicleTypes(types.data)
  //       setVehicleMakes(makes.data)
  //       setVehicleModels(models.data)
  //       setLoading(false)
  //       console.log(data)

  //     } catch (error) {
  //       setLoading(false)
  //       console.log(error)
  //     }
  //   };

  useEffect(() => {

    setBookingOrderTimeSlotModalIsOpen(false)
    setBookingInfoError('')
    setBookingOrderTimeSlotData('')

    props.onLoad(agent.Auth.current());


    let orderID = location.pathname.split('/')[2];

    getOrderDetails(orderID);
    bikeInfo(orderID);


  }, []);



  useEffect(() => {
    if (bikeTypes) {
      bikeMakeInfo(bikeTypes);
    }
    if (bikeMakes) {
      bikeModelInfo(bikeMakes);
    }
  }, [bikeMakes, bikeTypes]);



  const bikeInfo = async (orderID) => {
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/type', config);
      // console.log("data of bikes", data);
      setBikeTypeOptions(data.results);
      // console.log("bikelist", bikeTypeList)
    } catch (error) {
     // console.log(error);
    }
  };

  const bikeMakeInfo = async (bikeTypes, orderID) => {
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make', config);
      setBikeMakeList(data.results)
      // console.log("vehicleMake", bikeMakeList)
    } catch (error) {

    }
  }

  const bikeModelInfo = async (bikeMakes, orderID) => {
    // const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken);
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // 'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/gear', config);
      setBikeModelList(data.results)
      // console.log("vehicleModel", bikeModelList)
    } catch (error) {

    }
  }


  const getOrderDetails = async (orderID) => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      // console.log("order-id", pathname[2]);
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `order/${pathname[2]}`, config);
      setOrdersData(data)
      // const [types, makes, models] = await Promise.all([
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/types', config),
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/make', config),
      //   axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + 'vehicle/model', config)
      // ]);
      // setBikeTypes(types.data)
      // setBikeMakes(makes.data)
      // setBikeModels(models.data)
      // setTimeout(() => {
      //   setLoading(false)
      // }, 1000);
    //  console.log("edit orders Data", ordersData);

      setDefaultDate('date', data.results?.slot_date_time);
      // console.log("default-date", data.results?.slot_date);

      setValue('zip_code', data?.results.address?.zipcode);
      // setValue('mobile', data?.results?.mobile);
      setValue('city', data?.results.address?.city);
      setValue('state', data?.results.address?.state);
      // console.log("city-name", data?.results.address?.city);



      if (data?.results?.vehicle_gear) {
        let vehicle_info = data?.results?.vehicle_gear;
        let _bikeTypeList = [data?.results?.vehicle_type];
        // console.log("vehicle_info", vehicle_info);
        let _bikeMakeList = [data?.results?.vehicle_make];
        let _bikeModelList = [data?.results?.vehicle_gear];

        setBikeTypeList(_bikeTypeList);

        let selectedBikeType = _bikeTypeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeTypeList", _bikeTypeList)
        // console.log("selectedBikeType", selectedBikeType)
        setBikeTypes(selectedBikeType[0])
        setValue('biketype', selectedBikeType[0])

        /////////////////////////////////
        setBikeMakeList(_bikeMakeList);
        let selectedBikeMake = _bikeMakeList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeMakeList", _bikeMakeList)
        setBikeMakes(selectedBikeMake[0])
        setValue('bikemake', selectedBikeMake[0])

        ////////////
        setBikeModelList(_bikeModelList);
        let selectedBikeModel = _bikeModelList.map((item, index) => ({
          value: item?._id,
          label: item?.display_name
        }))
        // console.log("_bikeModelList", _bikeModelList)
        // console.log("selectedBikeModel", selectedBikeModel)
        setBikeModels(selectedBikeModel[0])
        setValue('bikemodel', selectedBikeModel[0])
        setBikesGearId(selectedBikeModel[0].value)
      }
      // setDefaultOrderDate(new Date (ordersData.results?.slot_date));
      // setValue('order_date', new Date (ordersData.results?.slot_date));
      let dateString = data.results?.slot_date_time;
      let date = new Date(dateString);

      // console.log("format-date", date);
      const year = date.getFullYear();
      // console.log("YEAR", year);
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      // console.log("MONTH", month);
      const day = ('0' + date.getDate()).slice(-2);
      // console.log("DAY", day);
      let orderDefaultDate = month + '/' + day + '/' + year;
      // console.log("date_format", orderDefaultDate);
      // 

      setDefaultOrderDate(orderDefaultDate);

      setValue('order_date', new Date(orderDefaultDate));

      setLoading(false);

    } catch (error) {
      setLoading(false)
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
    }
  };


  const getOrderDetailsTemp = async (orderID) => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      // console.log("order-id", pathname[2]);
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `order/${pathname[2]}`, config);
      setOrdersData(data);
      setLoading(false);

    } catch (error) {
      setLoading(false);
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
    }
  };

  // console.log("orderValue", ordersData);

  const slotTime = ordersData?.results?.slot_time; // Assuming slotTime is in minutes
  const hours = Math.floor(slotTime / 60);
  const minutes = slotTime % 60;

  let period = "AM";
  if (hours >= 12) {
    period = "PM";
  }
  let adjustedHours = hours % 12;
  if (adjustedHours === 0) {
    adjustedHours = 12;
  }

  function formatTime(hours, minutes, period) {
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${period}`;
  }


  const orderTime = formatTime(adjustedHours, minutes, period);

  // let orderTime = CustomFunction.toHoursAndMinutes(ordersData?.results?.slot_time);
  // console.log(orderTime);

  function dateFormat(dateString) {
    const date = new Date(dateString);
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options).replace(/, /g, ', ');
    return formattedDate;
  }

  // function dateFormat(dateString) {
  //   const date = new Date(dateString);
  //   const month = date.toLocaleDateString('en-US', { month: 'short' });
  //   const day = date.getDate();
  //   const year = date.getFullYear();
  //   const formattedDate = `${month}, ${day}, ${year}`;
  //   return formattedDate;
  // }

  const customClockStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? '#ff7f50' : provided.border,
      boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
      '&:hover': {
        border: '1px solid #ff7f50',
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      background: `url(${clockIcon})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      width: '20px',
      height: '20px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#ff7f50' : 'white',
      color: state.isSelected ? 'white' : 'black',
      fontSize: '1rem',
      '&:hover': {
        backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
        color: state.isSelected ? 'white' : 'black',
      },
    }),
  }
  const handleBikeValueChange = (selectedOption) => {
    // console.log("handleBikeValueChange", selectedOption.label)
    setBikeTypes(selectedOption);

  }

  const onChangeZipCode = async (value) => {
    let newZipCode = value.target.value;
    if (newZipCode.length !== 5 || isNaN(newZipCode)) {
      setValue('city', '');
      setValue('state', '');
      return;
    } else{
      // setLoading(true)
    
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `/zip-county/zipcode/${newZipCode}`, config);

      // setLoading(false);
      setValue('city', data?.results[0].city);
      setValue('state', data?.results[0].state);

      // let cityName = setCityName(data.results[0].city);
      // console.log("CITY", cityName)

    } catch (error) {
      setZipcodePopUp(true);
      HANDLE_401_ERROR(error.response?.status);
      // setCityName('');
     // console.log(error);
      // if(error.response.data.service_available == false) {
      //   setZipCodeServiceCheck('Please enter available zip code');
      // }
    }
  }
  }

  // const onChangeZipCode = async (value) => {
  //   let val = value.target.value;
  //   let vallenth = val.length
  //   if (vallenth == 5) {
  //     const accessToken = JSON.parse(localStorage.getItem("access_token"));
  //     try {
  //       const config = {
  //         headers: {
  //           "Content-Type": "application/json",
  //           'x-access-token': `${accessToken}`
  //         },
  //       };
  //       const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `country/zipcode?zipcode=` + val + `&country_code=US`, config);
  //       // setZipCodeServiceData(data);
  //       setZipCodeServiceCheck('')
  //       setValue('city', data.place);
  //     } catch (error) {
  //       if (error.response.data.service_available == false) {
  //         setZipCodeServiceCheck('Please enter available zip code');
  //       }
  //     }
  //   }
  // }

  // console.log(ordersData)
  // console.log("OrdersData")


  let address = ordersData?.results?.address?.address;
  let city = ordersData?.address?.city;
  let zipcode = ordersData?.address?.zipcode;
  let country = ordersData?.address?.country;

  let bikemake = ordersData?.vehicle_info?.make?.name;
  let bikemodel = ordersData?.vehicle_info?.model?.name;
  let biketype = ordersData?.vehicle_info?.type?.name;

  let orderdate = ordersData?.slot?.date;

  orderdate = new Date(orderdate * 1000).toString().substring(4, 15);
  // console.log(orderdate)

  // console.log(bikemake)
  // console.log("address", address)
  let serDetails = '';
  serDetails = props.services.orderService
 // console.log("service-details", serDetails);
  let replaceparts = ordersData?.order_details?.parts_replacement;
  let planid = '';

  let duration = ordersData?.results?.plan?.duration;
  





  // let modelOptions = [];
  // let typeOptions = [];
  // let makeOptions = [];
  // let makeOptionsDefaultVal = null;
  // let modelOptionsDefaultVal = null;
  // let typeOptionsDefaultVal = null;

  // if (vehicleMakes) {

  //   let data = vehicleMakes;
  //   makeOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   console.log(bikemake)
  //   makeOptionsDefaultVal = convertArrayToObject(makeOptions.filter(option => option.value === bikemake));
  //   console.log(makeOptionsDefaultVal)
  //   console.log("vehicleMakes")
  // }
  // if (vehicleTypes) {
  //   let data = vehicleTypes;
  //   typeOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   typeOptionsDefaultVal = convertArrayToObject(typeOptions.filter(option => option.value === biketype));
  // }
  // if (vehicleModels) {
  //   let data = vehicleModels;
  //   modelOptions = data.map(({ name, display_name }) => ({ value: name, label: display_name }));
  //   modelOptionsDefaultVal = convertArrayToObject(modelOptions.filter(option => option.value === bikemodel));
  // }

  // Get Slot Available Time Form
  const onSubmit = async (data) => {
    

   // console.log("Data on submit inside order edit", data);

    setBookingValues(data);

    setButtonLoading(true)
    setBookingInfoError('')
    setBookingOrderTimeSlotData('')
    // reset(bookingOrderTimeSlotData);
    const dateString = data.order_date;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const formattedDate = `${year}/${month}/${day}`;
    // console.log(formattedDate);


    // let orderDateIn = '';
    // if (data.order_date) {
    //   orderDateIn = data.order_date
    //   orderDateIn = Date.parse(orderDateIn) / 1000
    // }
    let country_code = 'US';
    let plan_id = data.plan_id;
    let zipcode1 = data.zip_code;


    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const response = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `check-slot?zipcode=${zipcode1}&date=${formattedDate}&duration=${duration}`, config);
      //console.log("error", response?.data?.results?.availabe_slots);
      // setSelectOrderTimeSlot(orderTime);
      setModalValue('order_slot_time', { disabled: false, label: orderTime, value: ordersData.slot_time })

      setBookingOrderTimeSlotData(response?.data?.results?.availabe_slots);
      // console.log("booking slot response", response?.data?.results?.availabe_slots);
      setBookingOrderTimeSlotModalIsOpen(true);
      setButtonLoading(false);
    } catch (error) {
      setBookingInfoError(error.response.data.message);
      HANDLE_401_ERROR(error.response?.status);
      setButtonLoading(false);
    //  console.log(error);
    }
    //return dispatch({ type: CHECK_AVAILABILITY_SLOT, payload: agent.OrderBooking.slot_availability(country_code, zipcode, plan_id, orderDateIn) })
  }

  // let availabilitySlotTime = [];
  // if(bookingOrderTimeSlotData.length > 0) {
  //   console.log(bookingOrderTimeSlotData)
  //   availabilitySlotTime = bookingOrderTimeSlotData;
  // }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };

  function bookingOrderTimeSlotModalIsCloseModal() {
    setBookingOrderTimeSlotModalIsOpen(false);
  }

  // Order Complete Popup
  const onBookingSubmit = async (data) => {

   // console.log("DATA ON Edit order BOOKING SUBMIT", data);
    setOrderTimeSlotButtonLoading(true)


    let orderDate = new Date(bookingValues.order_date).toLocaleDateString("en-US");
    //console.log("orderDate",orderDate);
    // let orderDateIn = '';
    // if (data.order_date) {
    //   orderDateIn = data.order_date
    //   orderDateIn = Date.parse(orderDateIn) / 1000
    // }

    // let partsFileUpload = OrdersData.imageupload.file_upload ? props.imageupload.file_upload : [];
    // let bikemakedt = data.bikemake ? data.bikemake.value : '';
    // let bikemodeldt = data.bikemodel ? data.bikemodel.value : '';
    // let biketypedt = data.biketype ? data.biketype.value : '';
    let orderSlotTime = data.order_slot_time ? data.order_slot_time.value : '';
    let val = {
      address: {
        address: bookingValues.address,
        city: bookingValues.city,
        state: bookingValues.state,
        country: 'United States',
        latitude: ordersData?.results?.address?.latitude ? ordersData?.results?.address?.latitude : '',
        longitude: ordersData?.results?.address?.longitude ? ordersData?.results?.address?.longitude : '',
        zipcode: bookingValues.zip_code
      },
      service: ordersData?.results?.service?._id ? ordersData?.results?.service?._id : '',
      parts_replacement: ordersData?.results?.parts_replacement ? ordersData?.results?.parts_replacement : '',
      plan: ordersData?.results?.plan?._id ? ordersData?.results?.plan?._id : '',
      slot_date: orderDate,
      slot_time: orderSlotTime,
      vehicle_images: ordersData?.results?.vehicle_images,
      vehicle_gear: bikesGearId,
      vehicle_type: bikesTypeId,
      vehicle_make: bikesMakeId
      // vehicle_images: partsFileUpload
    };

    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time' : new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.patch(process.env.REACT_APP_RIDEDOC_API_ROOT + `order/${pathname[2]}`, val, config);
      // console.log(data)
      setOrderSuccess(data);

      if (data) {
        getOrderDetailsTemp(pathname[2]);

        setOrderTimeSlotButtonLoading(false)
        setBookingModalISOpen(true);
        setBookingOrderTimeSlotModalIsOpen(false);
      }
    } catch (error) {
     // console.log(error);

      setBookingOrderError(error);
      HANDLE_401_ERROR(error.response?.status);
      setOrderTimeSlotButtonLoading(false)
    }
    // return dispatch({ type: ORDER_LOAD, payload: agent.OrderBooking.orderform(data) })
  }

  function bookingModalIsCloseModal() {
    setBookingModalISOpen(false);
    // navigate('/home');
    navigate(`/order-details/${orderSuccess?.results?._id}`);
  }

  // const handleResetOptions = () => {
  //   setValue('bikemake', '');
  //   setValue('bikemodel', '');
  // }

  const handleResetOptions = (selectedOption, selectedValue) => {
    if (selectedOption.value !== selectedValue) {
      setValue('bikemodel', '');
      setValue('bikemake', '');
    }
  };
  // const handleModelReset = () => {
  //   setValue('bikemodel', '');
  // }

  const handleModelReset = (selectedOption, selectedValue) => {
    if (selectedOption.value !== selectedValue) {
      setValue('bikemodel', '');
    }
  };
  // console.log("Date-default", defaultOrderDate);
  //console.log(" Edit order BOOKING ORDER SUCCESS DATASS", bookingOrderSuccess);

  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <Fragment>
      { !bookingOrderTimeSlotModalIsOpen && !bookingModalIsOpen ? (
      <div className='booking-info'>
        <div className='main'>
          <Helmet>
            <title>RideDoc | Booking Time</title>
            <meta name="description" content="Mobile bike mechanics at your door step" />
          </Helmet>
          <div className='header-wrp'>
            <header>
              <div className="header-backic">
                <button onClick={() => navigate(-1)} className="header-backic-icon">
                  <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
                </button>
              </div>
              <h1 className="header-mnutxt" style={{margin: "0 auto", paddingRight: "3rem"}}>Tune Up</h1>
            </header>
          </div>

          <div className='main-wrapper'>

            <div className="profile-info-wrp booking-wrp">
              <section className="profile-info-sec-wrp">
                {bookingInfoError && <span className='error'>{bookingInfoError}</span>}
                {bookingInfoSuccess && <span className='success'>{bookingInfoSuccess}</span>}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-hd-lbl bike-info-hd">
                    <h3>Bike Information</h3>
                  </div>
                  <div className="form-group-wrp">
                    <div className='row'>
                      <div className='col'>
                        <div className="form-group">
                          {/* <label className="form-select" htmlFor="biketype">Bike Type</label> */}
                          <Controller
                            name="biketype"
                            // isDisabled={editState}
                            control={control}
                            //value={bikeTypes}
                            defaultValue={bikesTypeId}
                            // defaultValue={bikeTypes}
                            render={({ field: { onChange, value } }) => (
                              <Select
                              isDisabled={true}
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: '#d3d3d3',
                                  cursor: 'not-allowed',
                                  border: state.isFocused ? '#ff7f50' : provided.border,
                                  boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                  '&:hover': {
                                    border: '0.5px solid #ff7f50',
                                  },
                                }),

                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                  color: state.isSelected ? 'white' : 'black',
                                  fontSize: '1rem', 
                                  '&:hover': {
                                    backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                    color: state.isSelected ? 'white' : 'black',
                                  },
                                }),
                              }}
                                // styles={customStylesSelect}
                                // isClearable
                                name="biketype"
                                placeholder="Bike Type"
                                isSearchable={false}
                                components={{ DropdownIndicator }}

                                className="react-dropdown dropdown-type react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeTypeOptions.map((item, index) =>
                                ({

                                  value: item?._id,
                                  label: item?.display_name
                                }))}
                                // onChange={onChange}
                                onChange={(selectedOption) => {
                                  //handleResetOptions(selectedOption, value);
                                  onChange(selectedOption);
                                }}
                                onInputChange={setBikesTypeId(value.value)}
                              // isOptionSelected={handleResetOptions}

                              />
                            )}
                          />
                        </div>
                      </div>
                      <div className="col">
                        <div className="form-group bike-select">
                          {/* <label className="form-select" htmlFor="bikemake">Bike Make</label> */}
                          <Controller
                            name="bikemake"
                            //value={bikeMakes}
                            control={control}
                            defaultValue={bikesMakeId}
                            // defaultValue={bikeMakes}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                isDisabled={true}
                                name="bikemake"
                                placeholder="Bike Make"
                                components={{ DropdownIndicator }}
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: '#d3d3d3',
                                    cursor: 'not-allowed',
                                    border: state.isFocused ? '#ff7f50' : provided.border,
                                    boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                    '&:hover': {
                                      border: '0.5px solid #ff7f50',
                                    },
                                  }),

                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: '1rem', 
                                    '&:hover': {
                                      backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                      color: state.isSelected ? 'white' : 'black',
                                    },
                                  }),
                                }}
                                // styles={customStylesSelect}
                                // defaultValue = {
                                //   makeOptions.filter(option => option.value === bikemake)
                                // }
                                // isClearable
                                // isDisabled={editState}
                                isSearchable={true}
                                className="react-dropdown react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeMakeList.map((item, index) => ({
                                  value: item?._id,
                                  label: item?.display_name
                                }))}
                                // onChange={onChange}
                                onChange={(selectedOption) => {
                                  //handleModelReset(selectedOption, value);
                                  onChange(selectedOption);
                                }}
                                onInputChange={setBikesMakeId(value.value)}
                              // isOptionSelected={handleModelReset}


                              />
                            )}
                          />
                        </div>
                        {errors.bikemake &&
                          <div className="invalid-feedback">{errors.bikemake?.message || errors.bikemake?.label.message}</div>
                        }
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="form-group model-select">
                          {/* <label className="form-select" htmlFor="bikemodel">Bike Model</label> */}
                          <Controller
                            name="bikemodel"
                            // value={bikeModels}
                            defaultValue={bikesGearId}
                            control={control}
                            // defaultValue={bikeModels}
                            render={({ field: { onChange, value } }) => (
                              <Select
                                isDisabled={true}
                                name="bikemodel"
                                placeholder="Gear Type"
                                components={{ DropdownIndicator }}
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: '#d3d3d3',
                                    cursor: 'not-allowed',
                                    border: state.isFocused ? '#ff7f50' : provided.border,
                                    boxShadow: state.isFocused ? '#ff7f50' : provided.boxShadow,
                                    '&:hover': {
                                      border: '0.5px solid #ff7f50',
                                    },
                                  }),

                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#ff7f50' : 'white',
                                    color: state.isSelected ? 'white' : 'black',
                                    fontSize: '1rem', 
                                    '&:hover': {
                                      backgroundColor: state.isSelected ? '#ff7f50' : '#ffdab9',
                                      color: state.isSelected ? 'white' : 'black',
                                    },
                                  }),
                                }}
                                // styles={customStylesSelect}
                                // defaultValue = {
                                //   modelOptions.filter(option => option.value === bikemodel)
                                // }
                                // isClearable
                                // isDisabled={editState}
                                isSearchable={false}
                                className="react-dropdown dropdown-model react-custom"
                                classNamePrefix="dropdown"
                                // defaultValue={value}
                                value={value}
                                options={bikeModelList.map((item, index) => ({
                                  value: item?._id,
                                  label: item?.display_name
                                }))}
                                onChange={onChange}
                                onInputChange={
                                  setBikesGearId(value.value)
                                }
                              />
                            )}
                          />
                        </div>
                        {errors.bikemodel &&
                          <div className="invalid-feedback">{errors.bikemodel?.message || errors.bikemodel?.label.message}</div>
                        }
                      </div>
                    </div>
                    {errors.biketype &&
                      <div className="invalid-feedback">{errors.biketype?.message || errors.biketype?.label.message}</div>
                    }
                  </div>
                  <div className="form-hd-lbl service-hd">
                    <h3>Service Information</h3>
                  </div>
                  <div className="form-group-wrp">
                    <div className="form-group service-grp">
                      <textarea className="form-control form-control-textarea" name="address" defaultValue={address} {...register('address')} id="address" cols="30" rows="20"></textarea>
                      <label className="form-lbl" htmlFor="address">Address</label>
                    </div>
                    {errors.address &&
                      <div className="invalid-feedback">{errors.address?.message}</div>
                    }
                    <div className="location-row" style={{ display: "flex", justifyContent: "space-between" }}>
                      <div className="zipcode-field" style={{ width: "25%" }}>
                        <div className="form-group zipcode-grp">
                          <input
                            name='zip_code'
                            className="form-control form-zipcode"
                            type="text"
                            maxLength={5}
                            defaultValue=''
                            {...register('zip_code', {
                              onChange: (e) => {
                                onChangeZipCode(e);
                              },
                            })}
                          />
                          {/* <input className="form-control" type="text" name="country" id="country" {...register('country')} defaultValue={country} hidden /> */}
                          <label className="form-lbl lbl-zipcode" htmlFor="zip_code">Zip Code</label>
                        </div>
                        {/* {zipCodeServiceCheck &&
                        <div className="invalid-feedback">{zipCodeServiceCheck}</div>
                           } */}
                        {errors.zip_code &&
                          <div className="invalid-feedback">{errors.zip_code?.message}</div>
                        }

                      </div>
                      <div className="city-field" style={{ width: "45%" }}>
                        <div className="form-group zipcode-grp">
                          <input className="form-control form-city" type="text" name="city" id="city" {...register('city')} readOnly defaultValue=''></input>
                          <label className="form-lbl lbl-city" htmlFor="city">City</label>
                        </div>
                        {errors.city &&
                          <div className="invalid-feedback">{errors.city?.message}</div>
                        }
                      </div>
                      <div className="state-field" style={{ width: "25%" }}>
                        <div className="form-group zipcode-grp">
                          <input
                            className="form-control form-state"
                            type="text"
                            name="state"
                            id="state"
                            //value={zipcode}
                            {...register('state')}
                          />
                          <label className="form-lbl lbl-state" htmlFor="state">State</label>
                        </div>
                        {errors.state &&
                          <div className="invalid-feedback">{errors.state?.message}</div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="form-hd-lbl date-hd">
                    <h3>Service Date</h3>
                  </div>
                  <div className="form-group-wrp">
                    <div className="row">
                      <div className="col form-group-right-ic">
                        <div className="form-group date-main">
                          {/* <label className="form-select" htmlFor="date">Choose a Date</label> */}
                          <div className='date-field' style={{ width: "50%" }}>
                            <Controller
                              control={control}
                              name='order_date'
                              render={({ field: { onChange, value } }) => (
                                <>

                                  <DatePicker
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText='Choose a Order Date'
                                    customInput={<ExampleCustomInput />}
                                    defaultValue={new Date(defaultOrderDate)}
                                    onChange={onChange}
                                    selected={value}
                                    minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                                    maxDate={addDays(new Date(), 7000)}
                                    className="form-control"
                                  />
                                </>
                              )}
                            />
                          </div>

                        </div>
                        {errors.order_date &&
                          <div className="invalid-feedback">{errors.order_date?.message}</div>
                        }
                      </div>
                      {/* <div className='date_img'>
                        <img src={dateIcon}></img>
                      </div> */}
                      <input hidden className="form-control" {...register('plan_id')} type="text" name="plan_id" id="plan_id" />
                      <input hidden className="form-control" {...register('replace_parts')} defaultValue={replaceparts} type="text" name="replace_parts" id="replace_parts" />
                    </div>
                  </div>
                  <div className="form-group timeslot-btn">
                    {isButtonLoading ?
                      <div className="btn btn-primary">Loading...</div>
                      :
                      <button className="btn btn-primary" type="submit">Pick Time Slot</button>
                    }
                  </div>
                </form>
              </section>
            </div>
          </div>
        </div>
        <Footer />
        </div>
      ) :
      (
        <div className='booking-info'>
          <Footer />
        </div>
      )}



      <Modal
        isOpen={bookingOrderTimeSlotModalIsOpen}
        onRequestClose={bookingOrderTimeSlotModalIsCloseModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        ariaHideApp={false}
        className="time-slot-popup"
        // style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="bookingOrderTimeSlot"
      >
        <div className='booking-wrp order-booking-time-popup'>
          <div className='rd-popup-wrp'>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                {/* {bookingOrderSuccess.order_id ?
                  <button className='reg-close' onClick={() => { navigate(`/order-details/${bookingOrderSuccess.order_id}`) }}>
                    <Icon path={mdiClose} size={'24px'} color="#222" />
                  </button>
                  : */}
                <button className='reg-close' onClick={bookingOrderTimeSlotModalIsCloseModal}>
                  <img src={closeIcon} alt='close Icon' />
                </button>
                {/* } */}
              </div>
            </div>
            {(bookingOrderSuccess?.results?._id) ?
              <div className="rd-popup-content ">
                <h2>Confirmation ID:{bookingOrderSuccess.order_id}</h2>
                <p className='pb10'>Thank you for your order. You will receive an email and text confirmation shortly. Your card will not be charged until the service is completed.</p>
                <div className="form-group">
                  <button className="btn btn-primary" onClick={() => { navigate(`/order-details/${bookingOrderSuccess.order_id}`) }}>View Orders</button>
                </div>
              </div>
              :
              <div className="rd-popup-content order-slot-cnt">
                <form onSubmit={modalhandleSubmit(onBookingSubmit)}>
                  <div className='form-group'>
                    <div className='order-slot-pop'>
                      <div className='row'>
                        <div className='col'>
                          <div className="form-group text-left">
                            <label className="form-select" htmlFor="order_slot_time">Choose availability Time Slot</label>
                            <Controller
                              name="order_slot_time"
                              control={modalControl}
                              defaultValue={{ value: orderTime, label: orderTime }}
                              render={({ field: { onChange, value } }) => (
                                <Select
                                  styles={customClockStyles}
                                  theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 0,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#ffdab9',
                                      primary: '#ff7f50',
                                    },
                                  })}
                                  components={{ DropdownIndicator: timeDropdownIndicator }}

                                  // defaultValue={selectOrderTimeSlot}
                                  isSearchable={false}
                                  className="react-dropdown popup_dropdown"
                                  classNamePrefix="dropdown"
                                  // options={bookingOrderTimeSlotData}
                                  options={bookingOrderTimeSlotData.map((item, index) => ({
                                    value: item?.value,
                                    label: item?.label
                                  }))}
                                  onChange={onChange}
                                  value={value}
                                  isOptionDisabled={(bookingOrderTimeSlotData) => bookingOrderTimeSlotData.disabled}
                                />
                              )}
                            />
                          </div>
                          {modalErrors.order_slot_time &&
                            <div className="invalid-feedback">{modalErrors.order_slot_time?.message || modalErrors.order_slot_time?.label.message}</div>
                          }
                          <div className="form-group" style={{ marginTop: 80, marginBottom: 80 }}>
                            {orderTimeSlotButtonLoading ?
                              <div className="btn btn-primary">Loading...</div>
                              :
                              <button className="btn btn-primary" type="submit">Confirm Booking</button>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </form>
              </div>

            }
          </div>
        </div>
      </Modal>


      <Modal
        isOpen={bookingModalIsOpen}
        onRequestClose={bookingModalIsCloseModal}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        ariaHideApp={false}
        className="time-slot-popup"
        // style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="bookingOrderTimeSlot"
      >
        <div className='booking-wrp order-booking-time-popup'>
          <div className='rd-popup-wrp'>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <img src={closeIcon} alt='close Icon' />
                </button>
              </div>
            </div>
            {/* {console.log("order-edit-success", orderSuccess)} */}
            {/* {console.log("order-data-temp-success", ordersData)} */}

            {(orderSuccess?.results?._id) &&
              <div className="rd-popup-content">
                <h2 className="confirm-order-title" style={{ paddingTop: 20 }}>Confirmation</h2>
                <div className="confirm-order-dollar">
                  <img src={dollarIcon} alt='dollar Icon' />
                  <div className='order-cost'>
                    <div className='confirm-order-cost'>
                      <span>
                        {ordersData?.results?.plan?.currency}{Math.ceil(ordersData?.results?.customer_cost)}
                      </span>
                    </div>
                  </div>
                  <div className='order-confirm-name'>
                    <span>{ordersData?.results?.plan?.display_name}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div className='order-confirm-details'>
          <h4 className='order_id'>Order No:  {orderSuccess?.results?.ref_id}</h4>
          <div className='popup-description'>
            <div className='order-date-details'>
              <div className='calendar-img'>
                <img src={calendarIcon} alt='calendar Icon' />
              </div>
              <div className='date-format'>
                <span style={{ paddingLeft: 3 }}>{dateFormat(orderSuccess?.results?.slot_date_time)}</span>
              </div>
            </div>
            <div className='order-clock-details'>
              <div className='clock-img'>
                <img src={orderClockIcon} alt='order clock Icon' />
              </div>
              <div className='clock-details'>
                <span style={{ paddingLeft: 3 }}>{orderTime}</span>
              </div>
            </div>
            <div className='order-duration-details'>
              <div className='duration-img'>
                <img src={durationIcon} alt='duration Icon' />
              </div>
              <div className='duration-details'>
                <span style={{ paddingLeft: 3 }}>{orderSuccess?.results?.plan_duration} Mins</span>
              </div>
            </div>
          </div>
          <p className='pb50' style={{ paddingTop: 20, paddingBottom: 90, fontSize: "1.15rem", width: "22.3rem", margin: "0 auto" }}>Thank you for trusting your ride with us. A RideDoc <b>will be</b> assigned to your order soon.</p>
        </div>
      </Modal>

      <Modal
        isOpen={zipcodePopUp}
        onRequestClose={closeModelZipcode}
        ariaHideApp={false}
        style={customStyles}
        overlayClassName="modal-Overlay"
        contentLabel="Example Modal"
      >
        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Hello</h2> 
       <button >close</button> */}

        <div className='booking-wrp'>
          <div className={cardAddPopup ? 'rd-popup-wrp' : 'rd-popup-wrp dn'}>
            <div className="rd-popup-hd">
              <div className="rd-popup-close">
                <div className='reg-close' onClick={closeModelZipcode}>
                  <Icon path={mdiClose} size={'24px'} color="#222" />
                </div>
              </div>
            </div>
            <div className="rd-popup-content order-slot-cnt">
              <p className='zipcode-popup-mssage'>Enter a Valid Zipcode.</p>
            </div>
          </div>
        </div>
         <div className='ok-button' style={{width: "21%", margin: "0 auto"}}>
            <button className="btn btn-primary btn-ok" onClick={closeModelZipcode}> OK </button>
          </div>
      </Modal>
    </Fragment >
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderEdit);